// src/components/Forms.js
import React from 'react';
import '../../style/components/forms.css';
import { useNavigate } from 'react-router-dom';

const Forms = () => {
  const navigate = useNavigate();

  return (
    <div>
      <main className="forms-page">
        <div className="card-container">

          <div className="card">
            <div className="card-cover">
              <h2>Senior Colleges</h2>
            </div>
            <div className="card-inside">
              <p>Access the Pay Fixation forms for teaching and non-teaching staff in senior colleges (non-agriculture, engineering, and diploma) for the efficient processing of salary adjustments and adherence to regulations.</p>
              <img src="/Images/senior-college.svg" alt="Senior Colleges Icon" className="card-svg" />
              {/* <p2 className="comingsoon text-center font-extrabold mt-4">Coming Soon...</p2> */}
              <button className="card-button" onClick={() => navigate('/SeniorCollege')}>Go to Form</button>
            </div>
          </div>

          <div className="card">
            <div className="card-cover">
              <h2>Primary, Secondary and Higher Secondary School</h2>
            </div>
            <div className="card-inside">
              <p>Access the Pay Fixation forms for teaching and non-teaching staff in Primary, Secondary, and Higher Secondary Schools for the efficient processing of salary adjustments and adherence to regulations.</p>
              <img src="/Images/primary-secondary-school.svg" alt="Primary Schools Icon" className="card-svg" />
              {/* <p2 className="comingsoon text-center font-extrabold mt-4">Coming Soon...</p2> */}
              <button className="card-button" onClick={() => window.location.href = './PriSecHSchool'}>Go to Form</button>
            </div>
          </div>

          <div className="card">
            <div className="card-cover">
              <h2>Government Office</h2>
            </div>
            <div className="card-inside">
              <p>Access the Pay Fixation forms for employees in Government Offices for the efficient processing of salary adjustments and adherence to regulations.</p>
              <img src="/Images/government-office.svg" alt="Government Office Icon" className="card-svg" />
              <p2 className="comingsoon text-center font-extrabold mt-4">Coming Soon...</p2>
              {/* <button className="card-button" onClick={() => window.location.href = './GovernmentOffice.html'}>Go to Form</button> */}
            </div>
          </div>

          <div className="card">
            <div className="card-cover">
              <h2>Arrears</h2>
            </div>
            <div className="card-inside">
              <p>Access the Arrear Pay Fixation forms for teaching and non-teaching staff in senior colleges, Primary, Secondary, Higher Secondary Schools, and Government Offices for the efficient processing of pending salary adjustments and compliance with regulations.</p>
              <img src="/Images/arrears.svg" alt="Arrears Icon" className="card-svg" />
              <button className="card-button" onClick={() => navigate('/Arrears')}>Go to Form</button>
            </div>
          </div>

          <div className="card">
            <div className="card-cover">
              <h2>Pension</h2>
            </div>
            <div className="card-inside">
              <p>Access the Pension Pay Fixation forms for teaching and non-teaching staff in senior colleges, Primary, Secondary, Higher Secondary Schools, and Government Offices for the accurate processing of pension adjustments and compliance with regulations.</p>
              <img src="/Images/pension.svg" alt="Pension Icon" className="card-svg" />
              {/* <p2 className="comingsoon text-center font-extraboldmt-4">Coming Soon...</p2> */}
              <button className="card-button" onClick={() => window.location.href = './pension'}>Go to Form</button>
            </div>
          </div>

        </div>
      </main>
    </div>
  );
};

export default Forms;
